import { useAuth } from "@workos-inc/authkit-react";

export function usePermissions(): string[] {
  const { permissions } = useAuth();
  return permissions ?? [];
}
